@if (visible && mode === "drawer") {
  <p-drawer
    [(visible)]="visible"
    (visibleChange)="onVisibleChange($event)"
    [dismissible]="closable"
    [closeOnEscape]="closable"
    [closable]="closable"
    position="bottom"
    blockScroll="true"
    styleClass="drawer-panel h-5/6 w-full {{ styleClass }}"
    appendTo="body"
  >
    <ng-template #header>
      <ng-container *ngTemplateOutlet="headerRef"></ng-container>
    </ng-template>
    <ng-template #content>
      <p-scrollpanel class="size-full">
        <ng-container *ngTemplateOutlet="contentRef"></ng-container>
      </p-scrollpanel>
    </ng-template>
    @if (footerRef) {
      <ng-template #footer>
        <ng-container *ngTemplateOutlet="footerRef"></ng-container>
      </ng-template>
    }
  </p-drawer>
} @else if (visible && mode === "dialog") {
  <p-dialog
    [modal]="true"
    [(visible)]="visible"
    (visibleChange)="onVisibleChange($event)"
    [dismissableMask]="closable"
    [closeOnEscape]="closable"
    [closable]="closable"
    (onHide)="onHide.emit()"
    (onShow)="onShow.emit()"
    styleClass="drawer-panel h-5/6 {{
      styleClass
    }} w-full md:max-w-[calc(var(--p-boxed)_-_50px)] m-auto overflow-hidden
"
    appendTo="body"
    blockScroll="true"
  >
    <ng-template #header>
      <ng-container *ngTemplateOutlet="headerRef"></ng-container>
    </ng-template>
    <ng-template #content>
      <p-scrollpanel class="size-full">
        <ng-container *ngTemplateOutlet="contentRef"></ng-container>
      </p-scrollpanel>
    </ng-template>
    @if (footerRef) {
      <ng-template #footer>
        <ng-container *ngTemplateOutlet="footerRef"></ng-container>
      </ng-template>
    }
  </p-dialog>
}
